<template>
    <div class="banner-wrap">
        <div class="banner-left-wrap">
            <div class="logo-wrap" @click="homePage()">
                <img src="../../static/logo.png" alt="" />
                <span>{{ logoText }}</span>
                <!-- <span class="version-wrap">{{ $version }}</span> -->
            </div>
            <div class="menus">
                <!--座位预约-->
                <div class="menu" :class="containName(['home', 'layout']) ? 'active' : ''" @click="changeTab(0)">{{
                    $t('tab.orders') }}
                </div>
                <!--记录查询-->
                <div class="menu" :class="containName(['my']) ? 'active' : ''" @click="changeTab(1)">{{ $t('tab.query') }}
                </div>
                <!--公告-->
                <div class="menu" @click="drawer = true">{{ $t('login.noticeTitle') }}</div>
                
                <!-- 外连接 -->
                <div class="menu" v-for="(item, index) in $linkBtn" :key="index" @click="handlerOpen(item)"> {{ $i18n.locale == 'zh' ? item.title : item.titleEn }}</div>
            </div>
        </div>
        <div class="banner-right-wrap">
            <div class="language-wrap">
                <el-select v-model="language" @change="languageChange">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                        size="medium">
                    </el-option>
                </el-select>
            </div>
            <div class="user-info-wrap regular">
                <div class="iconfont">&#xe63a;</div>{{ userInfo.fullName }}
                <template v-if="policyType == -1">( <span class="bold"
                        style="color:#1989FA;font-size: 24px;display: inline-block;margin:0px 3px;">{{
                            Number(userInfo.score ? userInfo.score : 0)
                        }}</span>
                    {{ $t('integral') }} )</template>
            </div>
            <div class="exit-button-wrap" @click="getCode" v-loading="codeLoading" v-if="vueConfig.showActCode">
                <span class="regular">{{ $t('code') }}</span>
            </div>
            <div class="exit-button-wrap" @click="exitLogin" v-if="JSON.parse(vueConfig.showBtn)">
                <div class="iconfont">&#xe611;</div>
                <span class="regular">{{ $t('exit') }}</span>
            </div>
        </div>

        <div class="activation-code" v-show="isCode">
          <div class="mask"></div>
          <div class="activation-code-box">
            <i class="el-icon-circle-close" @click="isCode=false"></i>
            <div class="code-content">
              <div class="code-head-bg"></div>
              <div class="code-box">
                <div class="code-item" v-for="(item, index) in activationCode" :key="index">{{ item }}</div>
                <!-- <div class="code-item">2</div>
                <div class="code-item">3</div>
                <div class="code-item">4</div>
                <div class="code-item">5</div>
                <div class="code-item">6</div> -->
              </div>
              <div class="code-info"><i class="el-icon-warning-outline" style="margin-right: 5px;"></i>{{ $t('timeInfo') }}</div>
            </div>
            <div class="info-text">{{ $t('tipe') }}</div>
            <div class="code-btn" @click="copyText(activationCode)">{{ $t('copy') }}</div>
            <div class="code-bottom-text" @click="isCode=false">{{ $t('nextTime') }}</div>
          </div>
        </div>

      <!-- 公告 -->
      <el-drawer :visible.sync="drawer" direction="ltr" :title="$t('login.noticeTitle')">
        <div class="notice-wrap">
          <template slot="title">
            <div class="notice-title-wrap bold">{{ $t('login.noticeTitle') }}</div>
          </template>
            <div class="notice-content-wrap" v-html="$i18n.locale== 'zh'?systemInfo.agreements:systemInfo.agreementsE"></div>
        </div>
      </el-drawer>
    </div>
</template>
  
<script>
import {
  setActivationCode,
  unbindCAS
} from '../api/index'
export default {
    data() {
        return {
            drawer: false,
            systemInfo: {},
            ruleText: '',
            ruleTextEn: '',
            noticeSystem: '',
            noticeSystemEn: '',
            policyType: 0,
            openTeam: false,
            logoText: '座位预约系统',
            weeks: [this.$t('login.Sunday'), this.$t('login.Monday'), this.$t('login.Tuesday'), this.$t('login.Wednesday'), this.$t('login.Thursday'), this.$t('login.Friday'), this.$t('login.Saturday')],
            nowDate: '',
            nowTime: '',
            nowWeek: '',
            userInfo: JSON.parse(sessionStorageProxy.getItem('userInfo')),
            vueConfig: JSON.parse(sessionStorageProxy.getItem('vueConfig')),
            timer: null,//更新时间定时器
            options: [
                {
                    value: 'zh',
                    label: '中文'
                }, {
                    value: 'en',
                    label: 'En'
                }
            ],
            noticeData: "",
            showNotice: false,
            language: '',
            isCode: false,
            codeLoading: false,
            activationCode: ''
        }
    },
    methods: {
      handlerOpen (item) {
        window.open(item.url)
      },
      // 获取激活码
        async getCode () {
          this.codeLoading = true
          const res = await setActivationCode()
          if (res.status == 200) {
            this.isCode = true
            this.activationCode = res.data.data
             this.codeLoading = false
          } else {
            this.$message.warning('获取激活码失败！')
             this.codeLoading = false
          }
        },
         copyText(text) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                this.$message.success('复制成功！')
            } catch (err) {
              this.$message.warning('复制失败！')
            }
            document.body.removeChild(textarea);
        },
        homePage: function () {
            this.$router.push({ path: '/main/home' })
        },

        //
        changeTab: function (type) {
            if (type == 0) {
                this.$router.push({ path: "/main/home", query: {} });
            } else if (type == 1) {
                this.$router.push({ path: "/main/my", query: {} });
            }
        },
        containName: function (pathName) {
            var path = this.$route.path;
            var exist = pathName.some((item, index) => {
                return this.$route.path.indexOf(item) > -1
            })
            return exist;
        },
        //退出登录
        exitLogin() {
            let vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
            let loginType = sessionStorageProxy.getItem('loginType')
            if (loginType === 'cas') {
                unbindCAS().then(res => {
                    if (res.data.status) {
                        sessionStorageProxy.removeItem('token')
                        sessionStorageProxy.removeItem('userInfo')
                        window.location.href = `${vueConfig.CASSSERVICE}/static/sso/loginout?redirectUrl=${(vueConfig.VUESERVICE)}`;
                    }
                })
            } else if (loginType === 'remLogin') {
                Dialog.alert({
                  title: '温馨提示',
                  message: '请关闭浏览器之后重新登录~',
                  confirmButtonColor: '#447EF2'
                }).then(res => {
                  sessionStorageProxy.clear()
                });
                // window.location.href = `${vueConfig.CASSSERVICE}/static/loginIndex`;
            } else {
                sessionStorageProxy.clear()
                this.$router.push({ path: "/login" })
            }
        },

        //语言切换
        languageChange(e) {
          if (e == 'zh') {
            window.document.title = this.systemInfo.vueConfig.htmlTitleZh
          } else {
            window.document.title = this.systemInfo.vueConfig.htmlTitleEn
          }
          localStorageProxy.setItem("languageType", e)
            this.$i18n.locale = e
            this.$forceUpdate();
        },
        //获取当前时间
        getDay() {
            let nowDate = new Date();
            let month = nowDate.getMonth() < 9 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
            let day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate();
            this.nowDate = nowDate.getFullYear() + "-" + month + "-" + day;
            this.nowWeek = nowDate.getDay();
        },
        //获取格式化时间
        getTime() {
            let nowDate = new Date();
            let hou = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours();
            let min = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes();
            let sec = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds();
            this.nowTime = hou + ":" + min + ":" + sec;
        },
    },
    created() {
      var systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
      this.systemInfo = systemInfo
    },
    destroyed() {

    }
}
</script>
  
<style lang="less" scoped>
.banner-wrap {
    height: 70px;
    display: flex;
    align-items: center;
    background: white;
    padding-right: 15px;

    .banner-left-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        cursor: pointer;

        .logo-wrap {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-left: 59px;
            min-width: 400px;

            img {
                width: 138px;
                height: 42px;
                display: block;
            }

            span {
                display: block;
                font-size: 25px;
                font-family: "YouSheBiaoTiHei";
                margin-left: 10px;
                font-weight: 400;
                color: #f4850b;
                margin-left: 11px;
                user-select: none;
            }

            .version-wrap {
                font-size: 16px;
                font-weight: bold;
                transform: translate(-8px, 4px);
            }
        }

        .menus {
            display: flex;
            cursor: pointer;

            .menu {
                margin-right: 60px;
                color: #6c6c6c;
            }

            .menu.active {
                color: #0f6ef2;
                position: relative;

                &::before {
                    content: " ";
                    bottom: -10px;
                    width: 100%;
                    background-color: #0f6ef2;
                    color: #0f6ef2;
                    position: absolute;
                    height: 3px;
                }
            }
        }

        .GlobalNotice {
            cursor: pointer;
        }

        .time-wrap {
            display: flex;
            align-items: center;
            font-size: 19px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #000000;
            margin-left: 10px;
            position: absolute;
            right: 0;

            .time-week-wrap {
                margin-left: 15px;
            }

            .time-date-wrap {
                margin-left: 15px;
            }
        }
    }

    .banner-right-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 39px;

        .user-info-wrap {
            display: flex;
            align-items: center;
            font-size: 20px;
            cursor: pointer;

            .iconfont {
                color: #409eff;
                font-size: 22px;
                margin-right: 5px;
            }
        }

        .exit-buttton-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 85px;
            height: 43px;
            background: #409eff;
            border-radius: 5px 5px 5px 5px;
            opacity: 1;
            user-select: none;
            cursor: pointer;
            margin-right: 83px;

            img {
                width: 12px;
                height: 12px;
            }

            .exit-button {
                margin-left: 5px;
                transform: translate(0px, -1px);
                font-size: 19px;
                font-weight: 400;
                color: #ffffff;
            }
        }
    }

    .exit-button-wrap {
        width: 85px;
        height: 35px;
        background: #409eff;
        border-radius: 5px 5px 5px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        cursor: pointer;
        margin-left: 25px;

        span {
            display: block;
            margin-left: 5px;
        }
    }

    .noticeModal {
        width: 100%;
        height: 50vh;
        overflow-y: scroll;
    }

    .closeNotice {
        background-color: #1682ff;
        width: 20%;
        color: white;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 50px;
        cursor: pointer;
    }
}

.activation-code {
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .7);
    z-index: 9;
  }
  .activation-code-box {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
    
    width: 340px;
    height: 430px;
    background-image: url("~@/assets/images/activation-code/activation-bg.png");
    background-size: 100% auto;

    .el-icon-circle-close {
      position: absolute;
      top: -10px;
      right: -10px;
      color: #fff;
      font-size: 30px;
      cursor: pointer;
    }

    .code-content {
      margin-top: 128px;
      padding: 0 20px;
      .code-head-bg {
        position: relative;
        z-index: 9;
        width: 250px;
        height: 36px;
        margin: 0 auto;
        background-image: url("~@/assets/images/activation-code/activation-header.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .code-box {
        position: relative;
        z-index: 5;
        width: 100%;
        height: 100px;
        margin-top: -30px;
        background: linear-gradient(180deg, #f6f6f6 0%, #edeeff 100%);
        opacity: 1;
        border-radius: 10px;
        border: 1px solid #3673fe;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding-top: 30px;
        
        .code-item {
          width: 38px;
          height: 38px;
          line-height: 38px;
          font-weight: bold;
          text-align: center;
          border-radius: 10px;
          border: 1px solid #5d80f2;
        }
      }
      .code-info {
        margin-top: -10px;
        padding: 20px 0 10px;
        font-size: 14px;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        color: #fff;
        background-color: #5d80f2;
      }
    }
    
    .info-text {
      margin-top: 20px;
      color: #546cfa;
      font-size: 12px;
      font-family: Source Han Sans SC-Regular, Source Han Sans SC;
      font-weight: 400;
    }

    .code-btn {
      width: 50%;
      margin: 23px auto 0;
      padding: 6px 0;
      font-size: 14px;
      color: #fff;
      background-color: #4a64f2;
      border-radius: 20px;
      cursor: pointer;
      font-weight: bold;
    }
    .code-bottom-text {
      margin-top: 20px;
      font-size: 12px;
      color: #546cfa;
      cursor: pointer;
    }
  }
}

.notice-wrap {
  padding: 20px;
  .notice-title-wrap {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    // color: white;
    letter-spacing: 3px;
    font-size: 20px;
    padding-bottom: 10px;
    transform: translate(0px, -5px);
  }

  .notice-content-wrap {
    flex: 1;
    margin-top: 10px;
    overflow: auto;
  }

  .notice-empty-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .iconfont {
      font-size: 80px;
      color: #999;
      transform: translate(0px, -50px);
      user-select: none;
    }

    .empty-desc {
      margin-top: 10px;
      letter-spacing: 0.5px;
      transform: translate(0px, -50px);
      color: #666;
      user-select: none;
    }
  }
}
</style>
<style lang="less">
.banner-wrap {
    .language-wrap {
        margin-right: 20px;

        .el-input--suffix .el-input__inner {
            width: 80px;
            background: transparent;
            border: none;
            font-family: "SCRegular";
            font-size: 18px;
        }

        .el-select .el-input .el-select__caret {
            color: black;
            font-size: 18px;
            font-weight: bold;
        }
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/banner.vue